import {ALARMAS_PS} from './alarmCodes'


// Función auxiliar para calcular el mensaje
export function getStatusMessage ({
  generador,
  controlType,
  bomba,
  bombaConectada,
  paradaEmergencia,
  alarmIndex,
  translate,
}) {

  // console.log("DEBUG alarms:", bomba.alarms, "alarmIndex:", alarmIndex, "controlType:", controlType, "bombaConectada:", bombaConectada, "paradaEmergencia:", paradaEmergencia);

  // Generador apagado sin alertas
  if (
    (generador?.partida === 60 && generador?.detencion === 100) ||
    generador?.hf_status === 60
  ) {
    return null;
  }

  if (controlType === "PS") {
    if (!bombaConectada) {
      return translate("device_com");
    }
    if (paradaEmergencia) {
      return translate("parada_emergencia");
    }
    if ((Array.isArray(bomba.alarms) && bomba.alarms.length > 0) || bomba.Status === 13) {
      const alarms = Array.isArray(bomba.alarms) ? bomba.alarms : [];
      if (alarms.length === 0) return translate("alerta");

      const code = alarms.length > 1 ? alarms[alarmIndex] : alarms[0];
      const descKey = ALARMAS_PS[code];
      // const desc = ALARMAS_PS[code] || translate("description_not_available");
      const desc = descKey ? translate(descKey) : translate("description_not_available");
      return `${code} - ${desc}`;
    }
  }

  if (controlType === "VDF") {
    if (!bombaConectada) return translate("device_com");
    if (bomba.Fault !== 0) return bomba.Fault;
  }

  return null;
};
